module.exports = __webpack_public_path__ + "static/media/xIcon.dd655397.svg";